import { action, computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

import { Text } from 'bz-core-controls';

@inject('draftStore')
@observer
export default class FormulaEditor extends Component {
  @observable
  value = this.props.value;

  @computed
  get isValid() {
    const regEx = new RegExp(/^[A-Z_](\w?)+$/gim);
    return this.value.length === 0 || regEx.test(this.value);
  }

  @computed
  get keyExists() {
    const { field } = this.props.otherAttributes;
    const { draftStore } = this.props;

    //ignore if empty
    if (this.value.length === 0) {
      return false;
    }

    // check it doesn't use a reserved keyword (like avg or sum)
    if (draftStore.reservedFormulaKeys.includes(this.value)) {
      return true;
    }
    // check it doesn't already exist on an entity in the template
    const entities = Object.values(draftStore.rawTemplate.get('entityMap'));
    return entities.some(({ data }) => {
      return data.field !== field && !!data.formulakey && this.value === data.formulakey;
    });
  }

  @computed
  get errorText() {
    return this.keyExists
      ? 'Variable is already in use'
      : 'Variable is invalid, must begin with a letter or _ symbol and contain only these symbols, letters and numbers.';
  }

  @action.bound
  onChange(value: string) {
    this.value = value;
    this.props.isValid(this.isValid && !this.keyExists);
    this.props.onChange(value);
  }

  render() {
    return (
      <Text
        {...this.props}
        onChange={this.onChange}
        value={this.value}
        errored={!this.isValid || this.keyExists}
        errorText={this.errorText}
      />
    );
  }
}
